import request from "../Requests/requests";
import { loadDataTag } from "../store/tagsReducer";

export const getTags = () => {
    return async dispatch => {
        try {
            const response = await request.get('/Tag/Tags/', { params: {
                UserId: localStorage.getItem('userID')}})
            .then(response => response.data)
            .then(data => dispatch(loadDataTag(data)))
            const data = response.data
            return data
        } catch (error) {
            return error
        }
    }
}